"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorageHandler {
    static hasDataInLocalStorage(key) {
        return this.storage !== null && this.storage.getItem(key) !== null;
    }
    static getDataFromLocalStorage(key) {
        if (this.storage === null) {
            this.localStorageNoExistError();
            return null;
        }
        if (this.hasDataInLocalStorage(key) === false) {
            this.noSuchContentInLocalStorageError(key);
        }
        return this.storage.getItem(key);
    }
    static setDataToLocalStorage(key, value) {
        if (this.storage === null) {
            this.localStorageNoExistError();
            return;
        }
        this.storage.setItem(key, value);
    }
    static removeDataFromLocalStorage(key) {
        if (this.storage === null) {
            this.localStorageNoExistError();
            return;
        }
        if (this.hasDataInLocalStorage(key) === false) {
            this.noSuchContentInLocalStorageError(key);
        }
        this.storage.removeItem(key);
    }
    static localStorageNoExistError() {
        console.error('LocalStorageError');
    }
    static noSuchContentInLocalStorageError(key) {
        console.error(`NoSuchContentInLocalStorageError, LocalStorageKeyEnum: ${key}`);
    }
}
LocalStorageHandler.storage = ('localStorage' in window) ? window.localStorage : null;
exports.default = LocalStorageHandler;
